module.exports = __webpack_public_path__ + "static/media/men-full-shirt.07aef7d4.png";